export function pluralize(count: number, str0: string, str1: string, str2: string): string {
    if (count % 10 === 1 && count % 100 !== 11) {
        return str0.replace(/%d/g, count.toString());
    }

    if (count % 10 >= 2 && count % 10 <= 4 && (count % 100 < 10 || count % 100 >= 20)) {
        return str1.replace(/%d/g, count.toString());
    }

    return str2.replace(/%d/g, count.toString());
}
